
export default (store) => ({
  path: 'statement-reflection/:cardId',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const StatementReflection = require('./containers/StatementReflectionContainer').default

      /*  Return getComponent   */
      cb(null, StatementReflection)

    /* Webpack named bundle   */
    }, 'StatementReflection')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/MoneyTool/routes/StatementReflection/index.js
 **/